import React, { useEffect } from "react";
import "./assets/scss/themes.scss";
import RouteIndex from "Routes/Index";
import { loginSuccess, headingData } from "slices/auth/login/reducer";

import { useDispatch } from "react-redux";

function App() {
  let dispatch = useDispatch();
  const userDetail = JSON.parse(window.localStorage.getItem(`authUser`));
  console.log(userDetail);
  useEffect(() => {
    if (userDetail) {
      dispatch(loginSuccess(userDetail));
      dispatch(headingData(userDetail));
    }
  }, [userDetail]);

  return <RouteIndex />;
}

export default App;
